import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

const HERO_IMAGE = "/images/hero-image4.png";
  

export default function Hero() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
     {/* Background Image */}
<div className="absolute inset-0">
  <img
    src={HERO_IMAGE}
    alt="Al-Kasbah Butcher Shop"
    className="w-full h-full object-cover"
    loading="eager"
  />
  <div
    className="absolute inset-0"
    style={{
      background: "linear-gradient(135deg, rgba(61,0,0,0.55) 0%, rgba(0,0,0,0.45) 50%, rgba(61,0,0,0.7) 100%)"
    }}
  />
</div>
      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <div className="inline-block mb-6">
          <span
            className="text-xs uppercase tracking-[0.3em] font-medium px-4 py-2 border border-white/30 rounded-full"
            style={{ color: "#D4AF37" }}
          >
            Est. 2015
          </span>
        </div>

        <h1
          data-testid="hero-title"
          className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight leading-tight"
        >
          Al-Kasbah
        </h1>

       

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            data-testid="hero-cta-products"
            onClick={() => scrollTo("products")}
            className="px-8 py-3 text-base font-semibold rounded-none text-white border-0"
            style={{ backgroundColor: "#8B0000" }}
            size="lg"
          >
            {t("hero.ctaProducts")}
          </Button>
          <Button
            data-testid="hero-cta-contact"
            onClick={() => scrollTo("contact")}
            variant="outline"
            className="px-8 py-3 text-base font-semibold rounded-none border-white/40 text-white hover:bg-white/10 hover:text-white"
            size="lg"
          >
            {t("hero.ctaContact")}
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("intro")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors animate-bounce"
        aria-label="Scroll down"
      >
        <ChevronDown className="h-8 w-8" />
      </button>
    </section>
  );
}
